
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.5 1.5a.5.5 0 00-1 0V2h-5v-.5a.5.5 0 00-1 0V2H3a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1V3a1 1 0 00-1-1h-1.5v-.5zM13 5V3h-1.5v.5a.5.5 0 01-1 0V3h-5v.5a.5.5 0 01-1 0V3H3v2h10zM3 6h10v7H3V6z","fill":"currentColor"}})])
          )
        }
      }
    